import { Tokens } from '@tmov/design-system/theme/types';
import styled from 'styled-components';

export const CotacaoContainer = styled.button`
  min-width: 23%;
  gap: 24px;
  padding: 32px;

  cursor: pointer;

  background: ${Tokens.eixods.colors.neutral.grey[0]};
  border: none;
  border-radius: 8px;

  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0px 2px 12px 2px rgba(0, 0, 0, 0.04),
      0px 8px 16px rgba(0, 0, 0, 0.06);
  }
`;

export const LogoContainer = styled.div`
  height: 60px;

  display: flex;
  align-items: center;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const TimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Separator = styled.div`
  width: 100%;
  border: 1px solid ${Tokens.eixods.colors.neutral.grey[5]};
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  span {
    color: ${Tokens.eixods.colors.neutral.grey[70]};
  }
`;
